<template>
    <div>
        <el-menu default-active="1" class="el-menu-group" mode="horizontal" @select="handleSelect" >
            <el-menu-item index="1">数据报表</el-menu-item>
            <el-menu-item index="2">转化报表</el-menu-item>
        </el-menu>
        <div style='margin-top:30px'></div>
        <div class="line"></div>
        <v-content1 v-if="itemVal==1"></v-content1>
        <v-content2 v-if="itemVal==2"></v-content2>
    </div>
</template>

<script>
import vContent1 from './DataBody3.vue';
import vContent2 from './DataBody4.vue';
export default {
    data() {
        return {
            itemVal:'1',
        }
    },
    components: { 
        vContent1,
        vContent2,
    },
    methods: {

        refresh(){
            history.go(0); 
        },
        //在线销户
        destoryPhone(){
            window.open("https://doc.weixin.qq.com/forms/AF0AYgdVAD0AVcA2QapACQnrOLkAlnRBf");
        },
        handleSelect(key, keyPath) {
            this.itemVal = key;
        },
    }
}
</script>
<style scoped>


</style>
